import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './Preloader.css';
import { Spinner } from './Spinner';

export const Preloader = ({
  isVisible,
  zIndex = 2000,
  inline = false,
  height = '100%',
}) => (
  <div
    className={cx('preloader', { visible: isVisible, 'inline-preloader': inline })}
    style={{ zIndex, height }}
  >
    <div className="preloader-middle">
      <Spinner />
    </div>
  </div>
);

Preloader.propTypes = {
  isVisible: PropTypes.bool,
  zIndex: PropTypes.number,
  inline: PropTypes.bool,
  height: PropTypes.string,
};
